import { useState, useEffect } from 'react';

/**
 * Stores state in browser history,
 * making the state reusable across navigation
 * but resets on refresh.
 *
 * @param {string} key The key to store in history
 * @param {any} defaultTo A default value if nothing exists in history
 */
export function useHistoryState(key, defaultTo) {
  const [state, setState] = useState(() => {
    const value = window.history.state?.[key];
    return value !== undefined ? value : defaultTo;
  });

  useEffect(() => {
    window.history.replaceState(
      { ...window.history.state, [key]: state },
      document.title
    );
  }, [key, state]);

  return [state, setState];
}
